import { Snackbar, SnackbarContent, Button } from "@mui/material";
import React from "react";

interface NotifyAboutChangesProps {
  hasChanged: boolean
  handleReset: () => void
  handleSave: () => void
}
const NotifyAboutChanges: React.FC<NotifyAboutChangesProps> = ({ hasChanged, handleReset, handleSave }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={hasChanged}
    >
      <SnackbarContent
        sx={{
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid #ccc',
          boxShadow: 2,
          width: 600
        }}
        message="Careful &mdash; You have unsaved changes"
        action={<React.Fragment>
          <Button variant="text" color="error" size="small" onClick={handleReset}> Reset </Button>
          <Button variant="contained" color="success" size="small" onClick={handleSave}> Save Changes</Button>
        </React.Fragment>
        }
      />
    </Snackbar>
  )
}

export default NotifyAboutChanges
